import {useNavigate} from "react-router-dom";
import {useRef} from "react";

/**
 * 메인 > 주체
 */
const PersonSearch = () => {

    const navigate = useNavigate();

    const term = useRef('');

    // 검색어 지정
    const handleTerm = (e) => {
        term.current = e.target.value;
    }

    // 검색
    const handleSearch = () => {

        if (term.current.length > 0) {
            let input = term.current;
            // setGlobalSearchType(input);
            navigate(`/person_search/${input}`);
        }
    }


    const onKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    return (
        <main id="contents">
            <div className="sub-content">
                <div className="school-wrap">
                    <div className="cont-top">
                        <div className="w-set">
                            <div className="title-wrap">
                                <h2 className="title batang">주체</h2>
                                <p className="text">일제강점기 학력 엘리트 및 교원정보를 <br/>찾아볼 수 있습니다.</p>
                            </div>
                        </div>
                    </div>
                    <div className="cont-btm">
                        <div className="w-set">
                            <div className="about-wrap">
                                <div className="video-wrap">
                                    <div className="video-box type-tall">
                                        <img src="/images/search/person_search_img.jpg" alt="교육박물관 소장 사진" />
                                    </div>
                                    <p className="caption">교육박물관 소장 사진</p>
                                </div>
                                <div className="school-search">
                                <div className="text-wrap">
                                        <p className="sub-tit">일제강점기 학력엘리트와 교원 정보</p>
                                        <p>
                                            일제강점기 학력엘리트 DB는 일제강점기 중등·고등교육기관에 재학하였을 것으로 추정되는 한국인 ‘학력엘리트’와 당시의 교원에 대한 정보를 19만 건 수록하고 있습니다.
                                        </p>
                                        <p>
                                            교원은
                                            일제강점기 엘리트의 가장 중요한 사회 진출의 통로이자 해방 이후 한국 지식사회 형성에 결정적인 역할을 하였기 때문에 학생과 교원을 아우르는 DB는 일제강점기 엘리트의 사회적 계보를 해명하고 근현대 지성사를 이해할 수 있는 토대가
                                            됩니다.
                                        </p>
                                        <p>
                                            핵심적인 대상자료군은 당사자가 생산하여 정확성을 확보하고 있는 학교일람류, 교지, 교우회지 등이고, 이를 보완할 자료들은 "조선총독부 관보", 관공립학교 교원의 임면 정보가 담긴 "경기도보", 개별학교의 학적부, 학위록, 이력서, 판결문,
                                            신문조사, 졸업앨범, 학교사, 신문, 잡지 등입니다.
                                        </p>
                                        <p>
                                            이로써 구축된 학력정보는 근현대 학력엘리트 집단의 학력정보의 객관성을 판단하는 기준 데이터로 역할을 하게 됩니다.
                                        </p>
                                    </div>
                                    <div className="search-wrap">
                                        <form action="">
                                            <div className="search-box">
                                                <div className="search-area">
                                                    <div className="input-wrap">
                                                        <label htmlFor="search">
                                                            <input type="text" name="search" id="search"
                                                                   placeholder="인물명을 입력해주세요." onChange={handleTerm}
                                                                   onKeyDown={onKeyPress}/>
                                                        </label>
                                                        <button type="button" className="btn-search" onClick={handleSearch}>검색</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}

export default PersonSearch;